/* TCC product-page JS — promoted from dev (TCC Dev) to live.
   Wraps Spotlight's product__info-container children into a single
   .tcc-buy-stack div so the right-hand buy column doesn't stretch to
   match the (taller) description column in CSS grid. */

/* TCC product-page DOM tweak.

   Spotlight renders each product "block" (price, inventory, quantity, tax,
   buy-form) as a direct child of .product__info-container. Once we flatten
   info-wrapper + info-container with `display: contents`, those blocks
   become direct grid items of .product alongside the (much taller) middle
   description column. CSS grid uses one row size per row across all
   columns, so the row that holds the price stretches to match the
   description's height — leaving a big gap between £price and "in stock".

   This script wraps the right-column blocks in a single .tcc-buy-stack
   div on page load. With one grid item in col 3, that cell's height
   is independent of the description column. Inside the wrapper we flex
   the items tightly with `gap: 0.4rem`. */
(function () {
  function wrap() {
    var containers = document.querySelectorAll('.product__info-container');
    containers.forEach(function (container) {
      if (container.querySelector(':scope > .tcc-buy-stack')) return;

      var selectors = [
        '[id^="price-template-"]',
        '.product__inventory',
        '[class*="product-form__quantity"]',
        '.product__tax',
        '.product-form',
        'product-form',
        '.product-form__buttons',
        '.shopify-payment-button',
        '.shopify-payment-button-wrapper'
      ];

      var items = [];
      selectors.forEach(function (sel) {
        container.querySelectorAll(':scope > ' + sel).forEach(function (el) {
          if (items.indexOf(el) === -1) items.push(el);
        });
      });

      container.querySelectorAll(':scope > *').forEach(function (el) {
        if (items.indexOf(el) !== -1) return;
        if (
          el.querySelector(':scope > product-form') ||
          el.querySelector(':scope > .product-form__buttons') ||
          el.querySelector(':scope > .shopify-payment-button')
        ) {
          items.push(el);
        }
      });

      if (items.length === 0) return;

      var stack = document.createElement('div');
      stack.className = 'tcc-buy-stack';
      items[0].parentNode.insertBefore(stack, items[0]);
      items.forEach(function (el) { stack.appendChild(el); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrap);
  } else {
    wrap();
  }
  document.addEventListener('shopify:section:load', wrap);
})();


